import React, { useEffect, useState } from "react";
import generatePDF from "../services/DogsReportGenerator";
import axios from "axios";
import DogsComponent from "./DogsComponent";

import { PDFViewer } from '@react-pdf/renderer';
import ReactPDF, { Page, Text, View, Document, StyleSheet, Image, Font, PDFDownloadLink, Svg } from '@react-pdf/renderer';

const Tickets = () => {
  
const [tickets, setTickets] = useState([]);
  

  useEffect(() => {
    const getAllTickets = async () => {
      try {
        const response = await axios.get("https://89.46.196.228:3000/api/devices");
        setTickets(response.data);
      } catch (err) {
        console.log("error");
      }
    };
    getAllTickets();
  }, []);

const reportTickets = tickets.filter(ticket => ticket.id < 1000);

var today = new Date();
const datum ='Datum: ' + today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

Font.register({
  family: "Roboto",
  src:
    "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf"
});

const styles = StyleSheet.create({
  page: {
    fontFamily: "Roboto"
  },
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    fontFamily: 'Roboto'
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: 'Roboto'
  },
  text: {
    margin: 12,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: 'grey',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
});

const MyDocument = () => (
  <Document>
    <Page size="A4" style={styles.page}>
	<Svg style={styles.text} width="300" height="70" viewBox="-10 -10 300 70">
		<Text style={styles.text} x="30" y="30">Savez lovačkih organizacija u Bosni i Hercegovini</Text>
		<Text style={styles.text} x="30" y="45">{datum}</Text>
	</Svg>
	
      <View style={styles.section}>
        <Text>Secč{datum}ion #1</Text>
      </View>
	  
      <View style={styles.section}>
        <Text>Secti{datum}on #2</Text>
      </View>

    {reportTickets.map(ticket => (
	
	true && ( 
	<>
	<View style={styles.text}>
    <Text>{ticket.ime}</Text> 
    </View>
	</>
	  )
    ))}
 
    </Page>
  </Document>
  )
  
  return (
    <div>
	
	<div>
	<PDFDownloadLink document={<MyDocument />} fileName="somename.pdf">
      {({ blob, url, loading, error }) =>
        loading ? 'Loading document...' : 'Download now!'
      }
    </PDFDownloadLink>
	</div>
	
    <div>
      <div className="container mb-4 mt-4 p-3">
        <div className="row">
          {false ? (
            <> </>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => generatePDF(reportTickets)}
            >
              Generate monthly report
            </button>
          )}
        </div>
      </div>

	
	{false ? (
	<PDFViewer width = "1200px" height = "800px" >
	<MyDocument />
	</PDFViewer>
	)
	:
	(
	<>
	</>
	)
	}
    </div>

	</div>
  );
};

export default Tickets;